<template>
  <!-- v-if="!chatroom.leave && (isListTabSel == chatListType || isListTabSel == 'ALL')" -->
  <li
    class="pnt"
    :class="`chat_list_li ${chatroom.new ? 'on' : ''}`"
    @click.prevent="enterRoom()"
  >
    <!--'on 추가'-->
    <div class="prof seller profile_line">
      <div class="inner">
        <img
          v-if="!chatroom.store.storeProfile"
          :src="setShopProfileImg(chatroom.store.name, chatroom.store.id)"
          alt=""
        />
        <img v-else :src="chatroom.store.storeProfile" alt="" />
        <img
          v-if="chatroom.store.cert === 1"
          class="mark"
          src="@/assets/front/images/new/icon_consent_s.png"
        />
      </div>
      <svg viewBox="0 0 100 100">
        <circle r="48.6" cx="50" cy="50"></circle>
      </svg>
    </div>
    <div class="txt_box">
      <div class="chat_list_ttl">
        <div class="ttl">
          <div class="store_name">
            {{ chatroom.store.name }}
          </div>
          <div class="btn_wrap" v-if="chatroom.store.followed">
            <!-- <label class="btn_like" @click.stop.prevent="toggleFollow()" [hsh - 20220107] -->
            <label class="btn_like"
              ><input type="checkbox" v-model="chatroom.store.followed" />
              <span class="i_heart"></span>
            </label>
          </div>
        </div>
        <div class="chat_time">{{ messageTime }}</div>
      </div>
      <div class="chat_list_con" v-if="chatroom.lastMessage">
        <i class="i_new"></i>{{ message }}
      </div>
    </div>
  </li>
</template>

<script>
import format from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import * as util from '@common/lib/common/utils.js';

import {
  mapActions as shopMapActions,
  mapGetters as shopMapGetters,
} from '@common/store/modules/shop';
import * as shopActions from '@common/store/modules/shop/types';
import * as shopGetters from '@common/store/modules/shop/getters';
import {
  mapActions as estimateMapActions,
  mapGetters as estimateMapGetters,
} from '@common/store/modules/estimate';
import * as estimationTypes from '@common/store/modules/estimate/types';
import { mapActions as commonMapActions } from '@common/store/modules/common';
import * as commonActions from '@common/store/modules/common/types';
import { authMapGetters, authGetters } from '@common/store/modules';
export default {
  props: {
    chatroom: Object,
    // isListTabSel: String, // ALL: 전체, MOBILE: 휴대폰, INTERNET: 인터넷
    // chatListType: String,
  },
  computed: {
    ...authMapGetters({
      currentUser: authGetters.CURRENT_USER,
    }),
    ...estimateMapGetters({
      autoEstimation: estimationTypes.AUTO_ESTIMATION,
    }),
    message() {
      let msg = '';
      console.log('this.chatroom.lastMessage====');
      console.log(this.chatroom.lastMessage);
      if (this.chatroom.lastMessage) {
        let { type, message } = this.chatroom.lastMessage;
        if (type == 'TEXT' || type == 'SYSTEM') {
          message = JSON.parse(message);
        }
        switch (type) {
          case 'TEXT':
            msg = message.text;
            break;
          case 'IMAGE':
            msg = '(이미지)';
            break;
          case 'FILE':
            msg = '(첨부파일)';
            break;
          case 'ESTIMATE':
            msg = '(견적요청서)';
            break;
          case 'QUOTATION':
          case 'MOBILE_ESTIMATE':
            msg = '(휴대폰견적서)';
            break;
          case 'BOOKING':
            msg = '(사전예약요청)';
            break;
          case 'INTERNETCOMMERCE':
          case 'INTERNETCOMMERCE_KT2408':
            msg = '(인터넷견적요청)';
            break;
          case 'INTERNETAPPLY':
          case 'INTERNET_APPLY_NOTICE':
          case 'INTERNET_PROMOTION_KT2408_NOTICE':
            msg = '(인터넷견적서)';
            break;
          case 'INTERNETAPPLYSUBMIT':
          case 'INTERNET_VOUCHER_OPEN_NOTICE':
          case 'INTERNET_PROMOTION_OPEN_KT2408_NOTICE':
            msg = '(인터넷가입신청서)';
            break;
          case 'MOBILE_REQUEST':
          case 'MOBILE_DEAL_NOTICE':
            msg = '(휴대폰견적요청)';
            break;
          case 'MOBILE_APPLY_SUBMIT':
          case 'MOBILE_APPLY_OPEN_NOTICE':
            msg = '(휴대폰개통신청서)';
            break;
          case 'VISIT_PROMISE':
            msg = '(방문약속)';
            break;
          case 'INTERNET_PROMOTION':
            msg = '(인터넷 프로모션)';
            break;
          case 'SYSTEM':
            // eslint-disable-next-line vue/no-parsing-error
            if (message.text.indexOf('자동견적서가 신청되었습니다') >= 0)
              msg = '(자동견적 요청)';
            if (
              // eslint-disable-next-line vue/no-parsing-error
              message.text.indexOf('자동 견적서 수신기간이 종료되었습니다') >= 0
            )
              msg = '(자동견적 종료)';
            // eslint-disable-next-line vue/no-parsing-error
            if (message.text.indexOf('자동견적서가 취소되었습니다') >= 0)
              msg = '(자동견적 해지)';
            break;
        }
      }
      return msg;
    },
    messageTime() {
      let time = '';
      const { createdAt } = this.chatroom.lastMessage;
      const created = format(parseISO(createdAt), 'yyyy-MM-dd');
      const now = format(new Date(), 'yyyy-MM-dd');
      if (created === now) {
        time = format(parseISO(createdAt), 'HH:mm');
      } else {
        time = format(parseISO(createdAt), 'yy.MM.dd');
      }
      return time;
    },
  },
  methods: {
    ...shopMapActions([shopActions.SHOP_FOLLOW, shopActions.SHOP_UNFOLLOW]),
    ...commonMapActions([commonActions.SET_DIALOG, commonActions.HIDE_DIALOG]),
    ...estimateMapActions([estimationTypes.FETCH_AUTO_ESTIMATION_IN_PROGRESS]),
    async toggleFollow() {
      const self = this;
      const shop = this.chatroom.store;
      const id = shop.id;
      const funAutoEstimationInProgress = async () => {
        await self[estimationTypes.FETCH_AUTO_ESTIMATION_IN_PROGRESS]({
          userId: self.currentUser.id,
          storeId: id,
        });
      };
      const funToggle = async function() {
        await self[
          shop.followed ? shopActions.SHOP_UNFOLLOW : shopActions.SHOP_FOLLOW
        ]({ id: id });
        //await self[shopActions.FETCH_SHOP]({ id: id });
        self.chatroom.store.followed = !self.chatroom.store.followed;
      };
      if (shop.followed) {
        await funAutoEstimationInProgress();
        if (self.autoEstimation.id) {
          self[commonActions.SET_DIALOG]({
            type: 'confirm',
            icon: 'warning',
            //title: this.$t('common.confirm'),
            message:
              '관심매장 해지시 자동견적서 발송이 취소 됩니다. 해지 하시겠습니까?',
            okCb: async () => {
              await funToggle();
              //this.$router.go(-1);
            },
          });
        } else {
          await funToggle();
        }
      } else {
        await funToggle();
      }
    },
    enterRoom() {
      this.$router.push({
        name: 'chat.room',
        params: {
          uuid: this.chatroom.uuid,
        },
      });
    },
    setShopProfileImg(shopName, shopId) {
      let path = util.setShopProfile(shopName, shopId, '120x120', '20');

      return path;
    },
  },
};
</script>
